import React, { useEffect, useState } from 'react';
import {Link, useNavigate} from 'react-router-dom';
import axios from 'axios';
import config from '../includes/ConfigFile.js';
import { error } from 'jquery';
//import { useCompany } from '../components/CompanyDetails.js';
import { useLanguage } from '../includes/LanguageContext.js'; // Importing Language Context
import { useAuth0 } from "@auth0/auth0-react";


const Nav=({ company })=>{
    const auth = localStorage.getItem("user");
    //const company = useCompany(); //Get Company Details from database
    //console.log("company 03-03-25");
    //console.log("Company Title:", company.company_title);

    const { currentLanguage, selectedLanguage, setSelectedLanguage } = useLanguage();

    //console.log("Current Language from context:", currentLanguage);

    const { logout: auth0Logout, isAuthenticated } = useAuth0();

    //Search Functionality
    const [searchQuery, setSearchQuery] = useState("");
    const handleSearch = (e) => {
    e.preventDefault();

    if (!searchQuery.trim()) return;

    navigate(`/search?q=${searchQuery}`);
    };
    
    const navigate = useNavigate();
    // const logout = ()=>{
    //     localStorage.clear();
    //     navigate('/signIn');
    // }
    const logout = () => {
        if (isAuthenticated) {
            // ✅ If user logged in with Auth0
            auth0Logout({
            logoutParams: {
                returnTo: window.location.origin, // redirect to home page after logout
            },
            });
        } else {
            // ✅ If user logged in via local Laravel API
            localStorage.clear();
            navigate('/signIn');
        }
        };


    const [languageData, setlanguageData] = useState([]);
    //const [selectedLanguage, setSelectedLanguage] = useState({ id: 1, name: "English" });

    useEffect(() => {
        axios.get(`${config.BASE_URL}/api/languages`)
            .then(response => {
                //console.log('Fetched data:', response.data); // Log the fetched data
                setlanguageData(response.data);
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }, []);

    const [categoryData,setcategoryData] = useState([]);
    useEffect( () => {
        if (selectedLanguage && selectedLanguage.id) {
           // alert(selectedLanguage.id);
        axios.get(`${config.BASE_URL}/api/categories/${selectedLanguage.id}`)
        .then(response => {
            //console.log("22-03-2025");
            //console.log(response.data);
            setcategoryData(response.data);
        })
        .catch(error => {
            console.error('Error fetching data :', error);
        });
    }
    },[selectedLanguage] );

    const handleLanguageChange = (language) => {
        setSelectedLanguage(language);
    };

    return(
        <>
            <nav className="navbar navbar-expand-lg navbar_bg" data-bs-theme="dark">
                <div className="container-fluid">
                    <a className="navbar-brand" href="/">
                    <img src={`${config.BASE_URL}/${company.company_logo}`} alt="Logo" style={{ width: "100%", height: "100px" }} className="d-inline-block align-text-top" />

                    {/* {company.company_title} */}
                    </a>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                        <li className="nav-item"><Link className='nav-link' to={"/"}> <i className="bi bi-house-add"></i> {currentLanguage.menu.home}</Link></li>
                        {/* <li className="nav-item"><Link className='nav-link' to={"/about"}> <i class="bi bi-balloon-heart"></i> About Us</Link></li> */}
                        <li className="nav-item dropdown"> 
                            
                            
                            <a
                                    className="nav-link dropdown-toggle"
                                    href="#"
                                    id="languageDropdown"
                                    role="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                        >
                                   <i class="bi bi-command"></i>  {currentLanguage.menu.category}
                                </a>
                                <ul className="dropdown-menu" aria-labelledby="categoryDropdown">
                                {categoryData.map((category, index) => (
                        
                                    <li key={index}>
                                    <Link className="dropdown-item" to={`/category/${category.id}/${selectedLanguage.id}`}>{category.category_name}</Link>
                                    </li>
                                    ))}
                                    
                                </ul>
                        </li>
                        {/* <li className="nav-item"><Link className='nav-link' to={"/contact"}> <i class="bi bi-person-lines-fill"></i> {currentLanguage.menu.contact}</Link></li> */}
                        <li className="nav-item">{auth || isAuthenticated ?'': <Link className='nav-link' to={"/signUp"}>{currentLanguage.menu.login}</Link>}</li>
                        <li className="nav-item">{auth || isAuthenticated ? <Link className='nav-link' to={"/profile"}>Profile </Link>:''}</li>
                         <li className="nav-item">{auth || isAuthenticated ? <Link className='nav-link' to={"/writer"}>Write </Link>:''}</li>
                        {/* <li className="nav-item"><Link className='nav-link' to={"/logout"}>Logout</Link></li> */}
                        {/* <li className="nav-item">{auth ? <Link className='nav-link' onClick={logout} to={"/signIn"}>Logout</Link>: 
                        <Link className='nav-link' to={"/signIn"}>{currentLanguage.menu.signup}</Link>}</li> */}
                        <li className="nav-item">
                            {auth || isAuthenticated ? (
                                <Link className="nav-link" onClick={logout} to={"/logout"}>
                                Logout
                                </Link>
                            ) : (
                                <Link className="nav-link" to={"/signIn"}>
                                {currentLanguage.menu.signup}
                                </Link>
                            )}
                        </li>
  
  
                        {/* <li className='nav-item dropdown languageDdesign'> 
                        <a
                                    className="nav-link dropdown-toggle"
                                    href="#"
                                    id="languageDropdown"
                                    role="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                        >
                                    Language
                                </a>
                                <ul className="dropdown-menu" aria-labelledby="languageDropdown">
                                {languageData.map((language, index) => (
                        
                                <li key={index}>
                                <Link className="dropdown-item" to={`/language/english${language.id}`}>{language.name}</Link>
                                </li>
                                ))}
                                   
                                </ul>

                        </li> */}
                        <li className='nav-item dropdown languageDdesign'>
                                <a className="nav-link dropdown-toggle" href="#" id="languageDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    {selectedLanguage.name}
                                </a>
                                <ul className="dropdown-menu" aria-labelledby="languageDropdown">
                                    {languageData.map((language, index) => (
                                        <li key={index}>
                                            <button className="dropdown-item" onClick={() => handleLanguageChange(language)}>
                                                {language.name}
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </li>
                    </ul>
                    {/* <form className="d-flex" role="search">
                        <input className="form-control me-2" type="search" placeholder="अपनी पसंदीदा कहानियां खोजें" aria-label="Search"/>
                        <button className="btn btn-outline-success" type="submit">Search</button>
                    </form> */}
                    <form className="d-flex" role="search" onSubmit={handleSearch}>
                        <input
                            className="form-control me-2"
                            type="search"
                            placeholder="अपनी पसंदीदा कहानियां खोजें"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                        <button className="btn btn-outline-success" type="submit">
                            Search
                        </button>
                    </form>
                    </div>
                </div>
            </nav>
        </>
    )
}

export default Nav;